/* WAKA home — scroll reveal, feature-split image rotator, reviews scroller, card links. Vanilla. */
(function () {
  /* ---- scroll reveal (.fadein -> .in) ---- */
  var els = document.querySelectorAll('.fadein');
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (e) { e.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.15 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---- feature-split image rotator ---- */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-rotator]').forEach(function (frame) {
    var imgs = Array.prototype.slice.call(frame.querySelectorAll('img'));
    var dots = Array.prototype.slice.call(frame.querySelectorAll('.rot-dots button'));
    var cap = frame.querySelector('.rot-cap');
    if (imgs.length < 2) return;
    var i = 0, paused = false;
    var interval = parseInt(frame.getAttribute('data-interval'), 10) || 3400;
    function show(n) {
      i = (n + imgs.length) % imgs.length;
      imgs.forEach(function (im, idx) { im.classList.toggle('on', idx === i); im.setAttribute('aria-hidden', idx !== i); });
      dots.forEach(function (d, idx) { d.classList.toggle('on', idx === i); });
      if (cap) cap.textContent = imgs[i].getAttribute('data-label') || '';
    }
    dots.forEach(function (d, idx) { d.addEventListener('click', function () { show(idx); }); });
    frame.addEventListener('mouseenter', function () { paused = true; });
    frame.addEventListener('mouseleave', function () { paused = false; });
    if (!reduce) setInterval(function () { if (!paused) show(i + 1); }, interval);
  });

  /* ---- video-reviews horizontal scroller ---- */
  document.querySelectorAll('[data-vid-row]').forEach(function (row) {
    var section = row.closest('section') || document;
    function step(dir) {
      var card = row.querySelector('.vid-card');
      var d = card ? card.offsetWidth + 18 : 360;
      row.scrollBy({ left: dir * d, behavior: 'smooth' });
    }
    var prev = section.querySelector('[data-vid-prev]');
    var next = section.querySelector('[data-vid-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  });

  /* ---- clickable cards (range / reviews) via data-href ---- */
  document.querySelectorAll('[data-href]').forEach(function (el) {
    el.style.cursor = 'pointer';
    el.addEventListener('click', function (e) {
      if (e.target.closest('a,button')) return;
      var url = el.getAttribute('data-href');
      if (/^https?:/.test(url)) window.open(url, '_blank'); else window.location.href = url;
    });
  });

  /* ---- FAQ accordion ---- */
  document.querySelectorAll('[data-accordion]').forEach(function (acc) {
    acc.querySelectorAll('.acc-q').forEach(function (q) {
      q.addEventListener('click', function () {
        var row = q.closest('.acc-row');
        var isOpen = row.classList.contains('open');
        acc.querySelectorAll('.acc-row.open').forEach(function (r) { r.classList.remove('open'); var b = r.querySelector('.acc-q'); if (b) b.setAttribute('aria-expanded', 'false'); });
        if (!isOpen) { row.classList.add('open'); q.setAttribute('aria-expanded', 'true'); }
      });
    });
  });

  /* ---- Viento ask field (page-head) ---- */
  document.querySelectorAll('[data-viento-ask-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var inp = form.querySelector('[data-viento-ask-input]');
      var v = inp ? inp.value.trim() : '';
      if (window.Viento) { if (v) { window.Viento.ask(v); inp.value = ''; } else { window.Viento.open(); } }
    });
  });

  /* ---- collection type filter (client-side) ---- */
  document.querySelectorAll('[data-collection]').forEach(function (col) {
    var fils = col.querySelectorAll('[data-col-fil]');
    var cards = Array.prototype.slice.call(col.querySelectorAll('.col-card'));
    var count = col.querySelector('[data-col-count]');
    var total = cards.length;
    fils.forEach(function (f) {
      f.addEventListener('click', function () {
        var cat = f.getAttribute('data-col-fil');
        fils.forEach(function (x) { x.classList.remove('active'); x.setAttribute('aria-selected', 'false'); });
        f.classList.add('active'); f.setAttribute('aria-selected', 'true');
        var shown = 0;
        cards.forEach(function (c) {
          var match = cat === 'all' || c.getAttribute('data-cat') === cat;
          c.style.display = match ? '' : 'none';
          if (match) shown++;
        });
        if (count) count.textContent = 'Showing ' + shown + ' of ' + total;
      });
    });
  });
})();
